export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-puzzle-e93bc10634b7e1e154234f6ababfb862.svg";